"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPosition = void 0;

var setPosition = function setPosition(_ref) {
  var position = _ref.position,
      _ref$offset = _ref.offset,
      left = _ref$offset.left,
      center = _ref$offset.center,
      right = _ref$offset.right;

  switch (position) {
    case 'left':
      return left;

    case 'center':
      return center;

    case 'right':
      return right;

    default:
      return 0;
  }
};

exports.setPosition = setPosition;